import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import React from "react";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import MainPage from "./components/MainPage";

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <MainPage />
      </Provider>
    </div>
  );
}

export default App;
